import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import Breadcrumbs from './Breadcrumbs';

const Wrapper = styled('div')`
  .fe-arrow-left {
    color: #323a46;
    margin-right: 10px;
  }

  .page-title-box {
    display: flex;
  }

  .page-title-count {
    margin: 30px 0 0;
    padding-left: 20px;
    color: #72747b;
  }

  .page-title-right {
    margin-left: auto;
    max-width: 50%;
    .breadcrumb {
      .breadcrumb-item.active {
        white-space: break-spaces;
      }
    }
  }

  .page-title {
    line-height: normal;
    margin: 25px 0;
    position: relative;
    display: flex;
    align-items: center;
    max-width: 50%;
  }

  @media (max-width: 540px) {
    .page-title-box {
      flex-wrap: wrap;
      margin-bottom: 20px;
      align-items: center;
    }
    .page-title {
      margin-right: 10px;
      max-width: unset;
    }
    .page-title-count {
      margin: 0;
      padding-left: 0;
    }
  }
`;

const PageTitle = (props) => {
  const {
    breadcrumbs,
    extraStr,
    title,
    pageTitleBadge,
    customBackLink = null,
    subtitle = null,
  } = props;

  useEffect(() => {
    if (title) {
      document.title = title + ' — Кактус';
    }
  }, [title]);

  const backLink = customBackLink
    ? customBackLink
    : breadcrumbs
    ? breadcrumbs[breadcrumbs.length - 2].route
    : null;

  return (
    <Wrapper className="row">
      <div className="col-12">
        <div className="page-title-box">
          <h4 className="page-title">
            {backLink ? (
              <Link to={backLink} data-testid="backLink">
                <i className="fe-arrow-left" />
              </Link>
            ) : null}
            <span className="d-flex flex-column justify-content-center">
              <span>{title}</span>
              {subtitle ? (
                <span className="text-muted font-14 font-weight-normal">{subtitle}</span>
              ) : null}
            </span>
            {pageTitleBadge ? (
              <span
                className="badge badge-blue"
                style={{ marginLeft: '10px', paddingBottom: '3px' }}
              >
                {pageTitleBadge.toLowerCase()}
              </span>
            ) : null}
          </h4>
          {extraStr ? <p className="page-title-count">{extraStr}</p> : null}
          <div className="page-title-right">
            {breadcrumbs ? <Breadcrumbs data={breadcrumbs} /> : null}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default PageTitle;
